import { cloneElement, ReactElement } from 'react';
import { useToggle } from './use-toggle';

/*
  This hook manages dialog state and exposes a few helper functions to toggle openness.
  You can also pass a React element to bind as a target to open/close the dialog.

  const { isOpen, close, TargetComponent } = useDialog(<button>Click me</button>)

  return (
    {TargetComponent}
    <Dialog isOpen={isOpen} onDissmiss={close} ...
  )
*/

export const useDialog = (target: ReactElement) => {
  const [isOpen, toggle] = useToggle(false);
  const close = () => toggle(false);
  const open = () => toggle(true);
  const onClick = (e: MouseEvent) => {
    e.preventDefault();
    toggle();
  };

  return {
    close,
    isOpen,
    open,
    TargetComponent: cloneElement(target, { onClick }),
    toggle,
  };
};
